var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "w-full h-full flex bg-[#FFFFFF] p-[20px] gap-[20px]"
  }, [_c('aside', {
    staticClass: "left h-full flex flex-col border-r-[1px] border-solid gap-[20px] pr-[10px] border-[var(--border-light,#f0eeed)]"
  }, [_c('div', {
    staticClass: "flex flex-col items-center gap-2"
  }, [_c('Input', {
    staticClass: "w-full",
    attrs: {
      "placeholder": _vm.placeholder,
      "suffix": "ios-search",
      "clearable": ""
    },
    on: {
      "on-enter": _vm.searchTable,
      "on-clear": _vm.searchTable,
      "on-change": _vm.searchTable
    },
    model: {
      value: _vm.search.keywords,
      callback: function ($$v) {
        _vm.$set(_vm.search, "keywords", $$v);
      },
      expression: "search.keywords"
    }
  })], 1), _c('main', {
    staticClass: "flex-1 min-h-0 overflow-y-auto"
  }, _vm._l(_vm.identityList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "text-left px-3 leading-[34px] hover:bg-[var(--surface-container-low,#f6f3f2)] rounded-[6px] text-[13px] font-[Manrope,sans-serif] cursor-pointer transition-colors",
      class: _vm.currentRole.code === item.code ? 'active' : '',
      on: {
        "click": function ($event) {
          return _vm.selectMenu(item);
        }
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 0)]), _c('section', {
    staticClass: "right flex-1 min-w-0 h-full bg-[#FFFFFF] box-border"
  }, [_c('pro-table', _vm._b({
    ref: "proTableRef",
    on: {
      "on-selection-change": _vm.handleSelectionChange
    }
  }, 'pro-table', _vm.config, false))], 1), _c('org-tree-modal', {
    ref: "orgTreeModalRef",
    attrs: {
      "disabledUnit": true
    },
    on: {
      "on-update": _vm.assignIdentity
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };